import * as moment from "moment";
import {toBase64, fromBase64} from "js-base64";

export default class Utils {
  static formatMoneyVND = (p) => {
    return this.formatMoney(p, 0, "");
  };

  static formatMoney = (number, places, symbol, thousand, decimal) => {
    places = !isNaN((places = Math.abs(places))) ? places : 2;
    symbol = symbol !== undefined ? symbol : "$";
    thousand = thousand || ".";
    decimal = decimal || ",";

    let negative = number < 0 ? "-" : "";
    let i =
      parseInt((number = Math.abs(+number || 0).toFixed(places)), 10) + "";
    let j = i.length;
    j = j > 3 ? j % 3 : 0;
    return (
      negative +
      (j ? i.substr(0, j) + thousand : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) +
      (places
        ? decimal +
          Math.abs(number - i)
            .toFixed(places)
            .slice(2)
        : "") +
      symbol
    );
  };

  static getParameterByName = (name, url = window.location.href) => {
    name = name.replace(/[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  };

  static copyStringToClipboard = (str) => {
    // Create new element
    var el = document.createElement("textarea");
    // Set value (string to be copied)
    el.value = str;
    // Set non-editable to avoid focus and move outside of view
    el.setAttribute("readonly", "");
    el.style = { position: "absolute", left: "-9999px" };
    document.body.appendChild(el);
    // Select text inside element
    el.select();
    // Copy text to clipboard
    document.execCommand("copy");
    // Remove temporary element
    document.body.removeChild(el);
  };

  static numToWords = (number) => {
    var digits = number.toString().length;

    if (digits > 9) {
      number /= 1000000000;
      return number.toFixed(1).replace(/\.?0+$/, "") + " tỷ";
    }
    if (digits > 6) {
      number /= 1000000;
      return number.toFixed(1).replace(/\.?0+$/, "") + " triệu";
    }
    return number.toString();
  };

  static upperFirstLetter = (words) =>
    words
      .split(" ")
      .map(
        (word) => word.slice(0, 1).toUpperCase() + word.slice(1, word.length)
      )
      .join(" ");

  static getTimeDiff = (date) => {
    if (!date) {
      return "";
    }
    const datetime = date;
    const now = new Date().getTime();

    // get total seconds between the times
    var delta = Math.abs(now - datetime) / 1000;

    // calculate (and subtract) whole days
    var days = Math.floor(delta / 86400);
    delta -= days * 86400;

    // calculate (and subtract) whole hours
    var hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

    // calculate (and subtract) whole minutes
    var minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;

    // what's left is seconds
    var seconds = delta % 60;

    if (days === 0 && hours === 0 && minutes === 0) {
      return Math.floor(seconds) + " giây trước";
    }

    if (days === 0 && hours === 0) {
      return minutes + " phút trước";
    }

    if (days === 0) {
      return hours + " giờ trước";
    }

    return days + " ngày trước";
  };


  static convertTimestampToDate = (t) => {
    return moment.unix(t).format("YYYY-MM-DD HH:mm:ss");
  };
  static convertTimestampToDateByFormat = (t, format) => {
    return moment.unix(t).format(format);
  };
  static getTitle(title, length = 0, appendString = "") {
    if (length === 0) return title;
    if (!title) return "";
    if (title.length <= length) return title;
    let newTitle = title.substr(0, length);
    newTitle = newTitle.substr(0, newTitle.lastIndexOf(" "));
    newTitle = newTitle.substr(0, newTitle.lastIndexOf(","));
    return newTitle + appendString;
  }
  static getLastWord(s) {
    if (!s) return "";
    s = s.trim();
    let lastIndexSpace = s.lastIndexOf(" ");
    if (lastIndexSpace > 0) {
      s = s.substring(lastIndexSpace);
    }
    return s;
  }
  static setHeight(eId, height, delay = 0)
  {
    try{
      if(delay > 0){
        setTimeout(
          () => {
            let div = document.getElementById(eId);
            if(div.offsetHeight < height){
              div.style.height = height + 'px';
            }
          }, 2000
        );
      }else{
        let div = document.getElementById(eId);
        if(div.offsetHeight < height){
          div.style.height = height + 'px';
        }
      }
    }catch(e){

    }
  }

  static nonAccentVietnamese(str) {
    str = str.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    // Some system encode vietnamese combining accent as individual utf-8 characters
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng
    str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư
    return str;
  }
  static encodeData(jsonData){
    let s = JSON.stringify(jsonData);
    let b = toBase64(s);
    return b;
  }
  static decodeData(b){
    let s = fromBase64(b);
    let jsonData = JSON.parse(s);
    return jsonData;
  }
  static empty(s){
    return s == undefined || s == null || s.trim() == '';
  }
}
function injectScriptSheet(name, url) {
  return new Promise((resolve, reject) => {
    if (name === null || name === undefined) return resolve();
    const head = document.head || document.getElementsByTagName("head")[0];
    const id = "".concat(name.toUpperCase(), "_SCRIPT");
    if (document.getElementById(id)) return resolve();
    const script = document.createElement("script");
    script.id = id;
    script.type = "text/javascript";
    script.src = url;
    script.onload = resolve;
    script.onerror = reject;
    head.appendChild(script);
  });
}

export async function injectDebugger() {
  await injectScriptSheet(
    "ERUDA_DEBUGGER",
    "https://cdn.jsdelivr.net/npm/eruda"
  );
  window.eruda.init();
}
